import { Component } from 'react';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
import * as Icons from './compiled';
import { Animation, Colors } from '../../../theme';
const sanitizeClassName = (size) => {
    return `${size}`.replace(/[^a-z0-9]/gi, '-');
};
const Styles = labelStyles('Icon', {
    root: (props) => [
        {
            label: `-${props.name}`,
            display: 'inline-block',
            fill: 'currentColor',
            transitionProperty: 'fill',
            transitionTimingFunction: Animation.transitionTimingFunction,
            transitionDuration: Animation.transitionDuration,
            '> svg': {
                display: 'block',
                height: 'inherit',
                width: 'inherit',
            },
            '*': {
                fill: 'inherit',
            },
        },
        !props.canAcceptPointerEvents &&
            withModifier('disable-pointer-events', {
                pointerEvents: 'none',
            }),
        props.isBlock &&
            withModifier('block', {
                display: 'block',
            }),
        withModifier(sanitizeClassName(`${props.size}x${props.size}`), {
            height: props.size,
            width: props.size,
        }),
        props.color &&
            withModifier(props.color, {
                fill: Colors[props.color],
            }),
    ],
});
const MissingIcon = () => (isolateComponent("svg", { "aria-label": "Could not load icon", "data-is-missing-icon": "true", viewBox: "0 0 24 24" },
    isolateComponent("rect", { height: "24", width: "24", x: "0", y: "0" })));
class IconErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            didFailToLoad: false,
        };
    }
    static getDerivedStateFromError() {
        return {
            didFailToLoad: true,
        };
    }
    render() {
        return this.state.didFailToLoad ? isolateComponent(MissingIcon, null) : this.props.children;
    }
}
export const Icon = ({ ariaLabel, color, isBlock, name, ariaHidden = true, canAcceptPointerEvents = true, size = 30, }) => {
    const IconComponent = getIcon(name);
    const stylesOptions = {
        name,
        canAcceptPointerEvents,
        isBlock,
        color,
        size,
    };
    return (isolateComponent("span", { "aria-hidden": ariaHidden ? 'true' : undefined, "aria-label": ariaLabel, css: Styles.root(stylesOptions), "data-testid": "iconContainer" },
        isolateComponent(IconErrorBoundary, null,
            isolateComponent(IconComponent, { size: size, color: color, name: name }))));
};
function getIcon(name) {
    try {
        if (name === 'miscAI') {
            return Icons['MiscAi'];
        }
        const capitalizedIcon = `${name[0].toUpperCase()}${name.substring(1)}`;
        return Icons[capitalizedIcon] || MissingIcon;
    }
    catch (_a) {
        return MissingIcon;
    }
}
//# sourceMappingURL=Icon.js.map
// @zapier/design-system@6.14.1 (10126c41d)
